<template>
    <div class="control">
        <ul class="box">
            <li>
                <a class="width60 shopCar" href="https://market.digiwincloud.com.cn/" target="_blank" @click="toDwCloudMarket"></a>
            </li>
            <li>
                <!-- <a class="width60 code" href="javascript:;" v-on:mouseenter="isCode=true" v-on:mouseleave="isCode=false"></a> -->
                <a class="width60 wx" href="javascript:;" v-on:mouseenter="isCode=true" v-on:mouseleave="isCode=false" style="line-height:60px;"></a>
            </li>
            <li>
                <a class="width60 phone" href="javascript:;" v-on:mouseenter="isPhone=true" v-on:mouseleave="isPhone=false"></a>
                <div v-show="isPhone" id="phone" class="item padding20">021-51791688-5057</div>
            </li>
        </ul>
    </div>
</template>
<script>
  export default {
    name: 'Control',
    data(){
        return {
            isCode: false,
            isPhone: false
        }
    },
    methods: {
        toDwCloudMarket() {//跳转云市场次数埋点
            this.$http.post('/backend/web/record', {
                pageName: 'dwCloudMarket',
                contentName : '',
                extend2: 'CN',
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/common/Control.vue